export default __webpack_public_path__ + "static/media/award-line1.e479a2b6.svg";